export default __webpack_public_path__ + "static/media/units.09e01f58.svg";